var _circle, _rect, _rect2, _path, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhiteBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 334,
    viewBox: "0 0 334 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 167,
    r: 167,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.3462,
    y: 96.3457,
    width: 44.9615,
    height: 141.308,
    fill: "#1A4049"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 192.692,
    y: 96.3457,
    width: 44.9615,
    height: 141.308,
    fill: "#1A4049"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.654 192.693L237.654 237.655L96.3461 237.655L96.3461 192.693L237.654 192.693Z",
    fill: "#1A4049"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 192.692,
    y: 192.693,
    width: 44.9615,
    height: 44.9615,
    fill: "#817AFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteBg);
export default __webpack_public_path__ + "static/media/logoWhiteBg.e0de1b459e32707dd2bafc7e65b5019b.svg";
export { ForwardRef as ReactComponent };